import $ from 'jquery'
import draggable from 'vuedraggable';

export default {
    name: 'manage-fields',
    components: {
        draggable
    },
    props: {
        selected_field: Object,
        liste_champs: Array,
        toggler: Number
    },
    data() {
        return {
            msg_error: "",
            save_loading: false,
            is_error: false,
            is_confirm: false,
        }
    },

    watch: {
        toggler() {
            this.msg_error = ""
            this.is_confirm = false,
            this.is_error = false
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        deactivateField(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            const data = {
                champ_id: this.selected_field.champ_id
            }

            this.save_loading = true
            this.$store.dispatch('deactivateChamp', data).then((response) => {
                if (response.success) {
                    this.successToast(response.message)
                    this.$emit('emitRefreshField')
                    this.$refs.deactivate_field.click()

                    this.is_confirm = false
                } else {
                    this.msg_error = response.message
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        },

        saveReorder() {
            let data = {
                champs: this.liste_champs
            }

            this.save_loading = true
            this.$store.dispatch('reorderFields', data).then((response) => {
                if (response.success) {
                    this.successToast(response.message)
                    this.$emit('emitRefreshField')
                    this.$refs.reorder_field.click()
                } else {
                    this.msg_error = response.message
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        },

        checkMove(evt) {
            return evt.draggedContext.element.is_default == 0;
        }
    }
}